import React, { useState } from 'react';
import './contact.css';
import { FaArrowRight, FaGithub, FaLinkedin } from 'react-icons/fa6';
import { FiMail, FiPhone } from 'react-icons/fi';
import portfolioConfig from '../../config/portfolioConfig';

const Contact = () => {
  const { personal, social } = portfolioConfig;
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((currentData) => ({
      ...currentData,
      [name]: value
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const subject = encodeURIComponent(formData.subject || `Project inquiry from ${formData.name}`);
    const body = encodeURIComponent(
      `Name: ${formData.name}\nEmail: ${formData.email}\n\n${formData.message}`
    );

    window.location.href = `mailto:${personal.email}?subject=${subject}&body=${body}`;
  };

  return (
    <section id="contact" className="contact-section section">
      <div className="container contact-section__container">
        <div className="contact-section__intro">
          <div>
            <p className="section-eyebrow">Contact</p>
            <h2>Need a portfolio refresh, a sharper landing page, or a product UI that feels more deliberate?</h2>
          </div>
          <p className="section-copy">
            The fastest way to start is an email with the problem, the timeline, and anything
            already live. I can help from visual direction through implementation.
          </p>
        </div>

        <div className="contact-layout">
          <aside className="contact-aside panel">
            <div className="contact-aside__block">
              <span>Email</span>
              <a href={social.email}>
                <FiMail /> {personal.email}
              </a>
            </div>
            <div className="contact-aside__block">
              <span>Phone</span>
              <a href={social.whatsapp} target="_blank" rel="noopener noreferrer">
                <FiPhone /> {personal.phone}
              </a>
            </div>
            <div className="contact-aside__block">
              <span>Profiles</span>
              <div className="contact-aside__socials">
                <a href={social.github} target="_blank" rel="noopener noreferrer">
                  <FaGithub /> GitHub
                </a>
                <a href={social.linkedin} target="_blank" rel="noopener noreferrer">
                  <FaLinkedin /> LinkedIn
                </a>
              </div>
            </div>
          </aside>

          <form className="contact-form panel" onSubmit={handleSubmit}>
            <div className="contact-form__row">
              <label>
                Name
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </label>
              <label>
                Email
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </label>
            </div>

            <label>
              Subject
              <input
                type="text"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
              />
            </label>

            <label>
              Message
              <textarea
                name="message"
                rows="6"
                value={formData.message}
                onChange={handleChange}
                required
              />
            </label>

            <button type="submit" className="btn btn-primary">
              Start the conversation <FaArrowRight />
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
